import { render, staticRenderFns } from "./Legend.md?vue&type=template&id=5fddaa27&"
import script from "./Legend.md?vue&type=script&lang=js&"
export * from "./Legend.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fddaa27')) {
      api.createRecord('5fddaa27', component.options)
    } else {
      api.reload('5fddaa27', component.options)
    }
    module.hot.accept("./Legend.md?vue&type=template&id=5fddaa27&", function () {
      api.rerender('5fddaa27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/doc/plugins/Legend.md"
export default component.exports